export default "__VITE_ASSET__D2_WWDIZ__"